import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import { withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { newsActions } from '../../store/newsStore';
import { isNullOrUndefined } from '../../store/storeFunctions';
import { Circles } from '../common/loadingComponent';
import NoDataComponent from '../common/noDataComponent';
import Paging from '../common/pagingComponent';
import NewsContent from './newsContent';
import NewsFooter from './newsFooter';

import "./news.css";

class NewsComponent extends React.Component {
    state = {
        news: []
    }

    componentDidMount() {
        const page = 1;
        this.props.getNotifications(page, this.includeNews, this.includeNotifications);
    }

    componentDidUpdate(prevProps) {
        var includeNews = this.endsWith(this.props.location.pathname, '/news');
        var includeNotifications = this.endsWith(this.props.location.pathname, '/news-notifications');

        if (this.props.languageChanged || this.props.pageReloadNeeded) {
            this.props.getNotifications(this.props.page, this.includeNews, this.includeNotifications);
        }
        if (includeNews != this.includeNews || includeNotifications !== this.includeNotifications) {
            this.includeNews = includeNews;
            this.includeNotifications = includeNotifications;
            this.props.getNotifications(1, this.includeNews, this.includeNotifications);
        }
    }

    endsWith = (str, suffix) => isNullOrUndefined(str) || isNullOrUndefined(suffix) ? false : str.lastIndexOf(suffix, str.length - suffix.length) === str.length - suffix.length;

    includeNews = this.endsWith(this.props.location.pathname, '/news');
    includeNotifications = this.endsWith(this.props.location.pathname, '/news-notifications');

    render() {
        return (
            <div className='content-root' style={{ paddingLeft: 0, paddingRight: 0, paddingTop: '1em' }}>
                {(this.props.isLoadingPaged === true && (!Array.isArray(this.props.dataPaged) || this.props.dataPaged.length === 0)) ? <Circles /> : <>
                    {(this.props.isLoadingPaged === false && (!Array.isArray(this.props.dataPaged) || this.props.dataPaged.length === 0)) && <NoDataComponent customLabel='Alerts.NoData' />}
                    {Array.isArray(this.props.dataPaged) && this.props.dataPaged.map(n => <div className="bb-news-widget" key={`${n.news ? 'news' : 'notification'}-${n.news ? n.news.newsId : n.notification.id}`}>
                        {n.notification && <>
                            <div className="bb-news-widget-content bb-news-widget-content-perex">
                                <span className={n.notification.seen ? "" : "notif-no-seen"}
                                    onClick={ev => { this.props.linkClick(ev, n.notification.id, this.props.history) }}
                                >
                                    {ReactHtmlParser(n.notification.description)}
                                </span>
                            </div>
                            <NewsFooter date={n.notification.completedFormated} notificationId={n.notification.id} isProcessing={n.notification.processing} />
                        </>}
                        {n.news && <>
                            <div className="bb-news-widget-header-box">
                                <div>
                                    <Link className="bb-news-widget-header-content" to={`/news/${n.news.newsId}`}>
                                        <span className="notif-seen">{!n.news.seen && <div className="notif-seen-value"></div>}{n.news.header}</span>
                                    </Link>
                                </div>
                            </div>
                            <NewsContent text={n.news.text} isPerex={true} newsId={n.news.newsId} />
                            <NewsFooter date={n.news.validFromFormated} annotation={n.news.annotation} seen={n.news.seen ? n.news.seenFormated : undefined} />
                        </>}
                    </div>)}
                    {this.renderPaging()}
                </>}
            </div>
        );
    }

    renderPaging = () =>
        (this.props.page && this.props.pageSize && this.props.dataPaged && Math.ceil(this.props.totalCountPage / this.props.pageSize) > 1) ? (
            <div className='paging-wrapper'>
                <Paging selectedPage={this.props.page}
                    totalPages={Math.ceil(this.props.totalCountPage / this.props.pageSize)}
                    setPage={page => this.props.getNotifications(page, this.includeNews, this.includeNotifications)} />
            </div>
        ) : null;
}

export default withRouter(withLocalize(connect(state => state.news, dispatch => bindActionCreators(newsActions, dispatch))(NewsComponent)));